const recursiveBuildFormData = (formData: FormData, data: any, parentKey = '') => {
  if (data && typeof data === 'object' && !(data instanceof File)) {
    Object.keys(data).forEach((key) => {
      recursiveBuildFormData(
        formData,
        data[key] as Record<string, unknown>,
        parentKey ? `${parentKey}[${key}]` : key,
      );
    });
  } else {
    formData.append(parentKey, data);
  }
};

export const createFormData = (data: any): FormData => {
  const formData = new FormData();
  recursiveBuildFormData(formData, data);
  return formData;
};
